exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n[v-cloak][data-v-bec033e0] {\ndisplay: none;\n}\n", ""]);

// exports
